import { useEffect } from "react";
import { META_PIXEL_ID } from "../../constants";

// Standard Meta Pixel base snippet, adapted to run once on mount rather than
// as an inline <head> script (see https://developers.facebook.com/docs/meta-pixel).
function loadFbq() {
  if (typeof window === "undefined" || window.fbq) return;

  const fbq = function (...args) {
    fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args);
  };
  window.fbq = fbq;
  window._fbq = window._fbq || fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.queue = [];

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);
}

export function MetaPixelProvider({ children }) {
  useEffect(() => {
    if (!META_PIXEL_ID) return;
    loadFbq();
    window.fbq("init", META_PIXEL_ID);
    window.fbq("track", "PageView");
  }, []);

  return (
    <>
      {children}
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: "none" }}
          src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`}
          alt=""
        />
      </noscript>
    </>
  );
}

// Fires a Meta Pixel "Purchase" event. Value/currency are only attached when
// both are present and valid — otherwise Meta requires them to be omitted
// entirely rather than sent as empty/zero.
export function trackPurchase({ value, currency } = {}) {
  if (typeof window === "undefined" || typeof window.fbq !== "function") return;

  const hasValue = typeof value === "number" && !Number.isNaN(value);
  const hasCurrency = typeof currency === "string" && currency.length > 0;

  if (hasValue && hasCurrency) {
    window.fbq("track", "Purchase", { value, currency });
  } else {
    window.fbq("track", "Purchase");
  }
}
